import React from 'react'
import Hero from '../Webinar/Hero'
import Hero2 from '../Webinar/Hero2'

const Webinar = () => {
  return (
    <div>
      <Hero />
    </div>
  )
}

export default Webinar
